import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 14,
	viewBox: "0 0 17 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.6121 7.00068C16.6121 7.75578 16 8.36787 15.245 8.36787H5.10158L8.14522 11.4115C8.67917 11.9455 8.67917 12.8112 8.14522 13.345C7.61119 13.879 6.74563 13.8789 6.21174 13.345L0.834111 7.96742C0.299404 7.43258 0.300772 6.56735 0.834111 6.03388L6.21174 0.656249C6.74569 0.12243 7.61133 0.122362 8.14522 0.656249C8.67917 1.1902 8.67917 2.05591 8.14522 2.58979L5.10158 5.63349H15.245C16 5.63349 16.6121 6.24558 16.6121 7.00068Z",
		fill: "#383838"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.245 8.36787C16 8.36787 16.6121 7.75578 16.6121 7.00068C16.6121 6.24558 16 5.63349 15.245 5.63349H5.10158L8.14522 2.58979C8.67917 2.05591 8.67917 1.1902 8.14522 0.656249C7.61133 0.122362 6.74569 0.12243 6.21174 0.656249L0.834111 6.03388C0.300772 6.56735 0.299404 7.43258 0.834111 7.96742L6.21174 13.345C6.74563 13.8789 7.61119 13.879 8.14522 13.345C8.67917 12.8112 8.67917 11.9455 8.14522 11.4115L5.10158 8.36787H15.245Z",
		fill: "#383838"
	})]
});
export default SvgArrow3;
